export const uk = {
    'add-keywords': 'Добавить в ключевые фразы',
    remove: 'Удалить'
};
